import { Stack, Typography } from "@mui/material";
import { FieldLabel } from "./FieldLabel";

interface Props {
  label: string;
  value: string | number | null | undefined;
}

const EM_DASH = "—";

function formatValue(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return EM_DASH;
  if (typeof value === "number") return value.toString();
  if (value.trim() === "") return EM_DASH;
  return value;
}

export function ReadOnlyField({ label, value }: Props): React.ReactElement {
  return (
    <Stack>
      <FieldLabel label={label} />
      <Typography variant="body1">{formatValue(value)}</Typography>
    </Stack>
  );
}
